const HeroSkeleton = () => {
  return (
    <div className="cht-relative cht-w-full cht-overflow-hidden cht-bg-slate-900/90 cht-min-h-[460px] sm:cht-min-h-[540px] lg:cht-min-h-[620px] cht-flex cht-items-center cht-animate-pulse">
      <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-w-full cht-py-12">
        <div className="cht-grid md:cht-grid-cols-12 cht-gap-8 lg:cht-gap-12 cht-items-center">
          <div className="md:cht-col-span-7 cht-space-y-4">
            <div className="cht-h-6 cht-w-32 cht-bg-white/10 cht-rounded-full" />
            <div className="cht-h-12 cht-w-4/5 cht-bg-white/15 cht-rounded-2xl" />
            <div className="cht-space-y-2.5 cht-pt-2">
              <div className="cht-h-4 cht-w-full cht-bg-white/10 cht-rounded-md" />
              <div className="cht-h-4 cht-w-5/6 cht-bg-white/10 cht-rounded-md" />
              <div className="cht-h-4 cht-w-3/5 cht-bg-white/10 cht-rounded-md" />
            </div>
            <div className="cht-flex cht-items-center cht-gap-4 cht-pt-4">
              <div className="cht-h-11 cht-w-36 cht-bg-white/20 cht-rounded-xl" />
              <div className="cht-h-11 cht-w-36 cht-bg-white/10 cht-rounded-xl" />
            </div>
          </div>
          <div className="md:cht-col-span-5">
            <div className="cht-h-[300px] sm:cht-h-[360px] cht-w-full cht-bg-white/10 cht-rounded-[24px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSkeleton;
